import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector, useDispatch } from "react-redux";
import { Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
import partner1 from "../../images/menagri.png";
import partner2 from "../../images/xenosol.png";
import partner3 from "../../images/knc.png";
import partner4 from "../../images/rady.png";
import cclicks from "../../images/cclicks.png";
import sgn from "../../images/sgn.png";
import playmob from "../../images/playmob.png";
import intech from "../../images/intech.png";
import bloom from "../../images/bloom.png";
import etisalat from "../../images/etisalat.png";
import touch from "../../images/touch.png";
import vodafone from "../../images/vodafone.png";
import zain from "../../images/zain.png";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Partners = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="partner-area">
        <div className="container">
          <h3
            data-aos="fade-in"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="200"
          >
            {t("static.partners.title")}
          </h3>

          <Swiper
            spaceBetween={20}
            breakpoints={{
              0: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 6,
              },
            }}
            autoplay={{
              delay: 6500,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }}
            modules={[Autoplay]}
            className="partner-slides"
            data-aos="fade-in"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="400"
          >
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={partner1} alt="logo" />
                </a>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={partner4} alt="logo" />
                </a>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={partner2} alt="logo" />
                </a>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={partner3} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={cclicks} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={playmob} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={sgn} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={intech} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={bloom} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            {/*
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={google} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={stc} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={ooredoo} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={mobily} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={korek} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={touch} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={zain} alt="logo" />
                </a>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="partner-item">
                <a>
                  <img src={etisalat} alt="logo" />
                </a>
              </div>
            </SwiperSlide> */}
          </Swiper>
        </div>
      </div>
      <style>
        {
          `
          .partner-area .partner-slides {
             direction: ltr;
          }
          `
        }
      </style>
    </>
  );
};

export default Partners;
